/**
 * Format an integer with thousands separator (user-locale) with fallback to en-US.
 */
const formatInt = (value: number) => {
	try {
		return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value);
	} catch {
		return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value);
	}
};

export { formatInt };
